import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { Collapse, message } from 'antd'
import { Modal } from 'antd'
import VendorPanel from './VendorPanel'
import { arrayMove, generateUniqueId } from '../util'
import { bindActionCreators } from 'redux'
import _ from 'lodash'
import { connect } from 'react-redux'
import { actions as auditActions } from '../redux/modules/auditActions'
import { actions as revisionActions } from '../redux/modules/revisionActions'
import { actions as purchaseOrderActions } from '../redux/modules/jobFunctions/purchaseOrderActions'
import PurchaseOrderCreationSteps from './purchaseorders/PurchaseOrderCreationSteps'
const Panel = Collapse.Panel
const panelStyle = {
  borderRadius: 0,
  overflow: 'auto'
}

class VendorView extends Component {
  vendorAdressForm = null
  constructor(props) {
    super(props)
    this.state = {
      modalIsShowing: false,
      vendorId: 0,
      purchaseOrderSections: [],
      purchaseOrderItems: [],
      purchaseOrderCreationStep: 0,
      selectedEstimateId: null,
      activeKey: 0
    }

    this.props.getRelatedLeadEstimates({ jobId: this.props.jobId })
    this.props.getAllItems()
  }

  componentDidUpdate(prevProps) {
    const { currentVendorId } = this.props

    if (currentVendorId !== prevProps.currentVendorId) {
      this.handlePanelChange(currentVendorId)
    }
  }

  handleAddPurchaseOrderClick = vendorId => {
    this.setState({
      modalIsShowing: true,
      vendorId: vendorId,
      purchaseOrderSections: [],
      purchaseOrderItems: []
    })
  }

  handleCancel = () => {
    Modal.confirm({
      title: 'Do you want to cancel?',
      content: 'Any changes will be lost',
      onOk: () => {
        this.setState({
          modalIsShowing: false,
          vendorId: 0,
          /* reset form manually */
          basicInfoDescription: null,
          basicInfoTerms: null,
          basicInfoShipTo: null,
          basicInfoAttention: null,
          purchaseOrderCreationStep: 0,
          purchaseOrderSections: [],
          purchaseOrderItems: []
        })
      },
      okText: 'Yes',
      cancelText: 'No'
    })
  }
  validateVendorAdressFormAsync = () => {
    return new Promise((resolve, reject) => {
      this.vendorAdressForm.validateFields((err, values) => {
        if (err) {
          return reject(err)
        }
        resolve(values)
      })
    })
  }
  handleCreate = async () => {
    let adressData
    try {
      if (+this.state.basicInfoShipTo === 4) {
        adressData = await this.validateVendorAdressFormAsync()
      }
    } catch (error) {
      return message.info('Please fill all the required fields')
    }

    const basicInfoData = {
      description: this.state.basicInfoDescription,
      terms: this.state.basicInfoTerms,
      shipping_address_id: this.state.basicInfoShipTo,
      shipping_address: adressData,
      attention: this.state.basicInfoAttention,
      estimate_id: this.state.selectedEstimateId
    }
    this.props.createVendorPurchaseOrder({
      jobId: this.props.jobId,
      vendorId: this.state.vendorId,
      basicInfoData: basicInfoData,
      sectionData: this.state.purchaseOrderSections,
      itemsData: this.state.purchaseOrderItems,
      userId: this.props.userId
    })

    message.success('Purchase Order Created.')
    this.setState({
      vendorId: 0,
      currentStep: 0,
      temptempSectionData: [],
      tempBasicInfoData: [],
      panel: 'TablePanel',
      basicInfoDescription: null,
      basicInfoTerms: null,
      basicInfoShipTo: null,
      basicInfoAttention: null,
      purchaseOrderCreationStep: 0,
      purchaseOrderSections: [],
      purchaseOrderItems: [],
      modalIsShowing: false
    })
  }

  ///////////////////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////////////

  addSection = () => {
    const { purchaseOrderSections } = this.state

    const sectionArray = [
      ...purchaseOrderSections,
      { name: `Section ${purchaseOrderSections.length + 1}`, id: generateUniqueId() }
    ]

    this.setState({
      purchaseOrderSections: sectionArray
    })
  }
  deleteItemsRelatedToSection = (items, sectionNumber) => {
    return items.filter(item => item.purchase_order_section_id !== sectionNumber)
  }

  // TODO: mark for deletion flasg nedded
  deleteSection = sectionNumber => {
    const sectionArray = this.state.purchaseOrderSections
    const index = sectionArray.findIndex(section => section.id === sectionNumber)
    sectionArray.splice(index, 1)
    this.setState({
      purchaseOrderSections: sectionArray,
      purchaseOrderItems: this.deleteItemsRelatedToSection(
        this.state.purchaseOrderItems,
        sectionNumber
      )
    })
  }

  moveSectionUp = sectionNumber => {
    const sectionArray = this.state.purchaseOrderSections
    const index = sectionArray.findIndex(section => section.id === sectionNumber)
    this.setState({
      purchaseOrderSections: arrayMove(sectionArray, index, index - 1)
    })
  }

  moveSectionDown = sectionNumber => {
    const sectionArray = this.state.purchaseOrderSections
    const index = sectionArray.findIndex(section => section.id === sectionNumber)
    this.setState({
      purchaseOrderSections: arrayMove(sectionArray, index, index + 1)
    })
  }
  moveItemUp = rowId => {
    const itemsArray = [...this.state.purchaseOrderItems]
    const itemIndex = itemsArray.findIndex(item => {
      return item.row_id === rowId || item.id === rowId
    })
    this.setState({
      purchaseOrderItems: arrayMove(itemsArray, itemIndex, itemIndex - 1)
    })
  }

  moveItemDown = rowId => {
    const itemsArray = [...this.state.purchaseOrderItems]
    const itemIndex = itemsArray.findIndex(item => {
      return item.row_id === rowId || item.id === rowId
    })
    this.setState({
      purchaseOrderItems: arrayMove(itemsArray, itemIndex, itemIndex + 1)
    })
  }

  deleteItem = rowId => {
    const itemArray = [...this.state.purchaseOrderItems]

    const currentItem = itemArray.find(item => {
      return item.row_id === rowId || item.id === rowId
    })

    const filteredItems = itemArray.filter(item => {
      return item.row_id !== rowId || item.id !== rowId
    })

    const newGrandTotal = filteredItems.reduce(
      (acc, nextVal) => acc + nextVal.cost * nextVal.quantity,
      0
    )

    if (currentItem) {
      let orderData = { ...this.state.orderBasicInfo, grand_total: newGrandTotal }
      this.setState({
        purchaseOrderItems: filteredItems,
        orderBasicInfo: orderData
      })
    }
  }

  addItem = (index, data) => {
    const { allItems } = this.props
    const itemsArray = this.state.purchaseOrderItems
    data.purchase_order_section_id = index

    const selectedItem = allItems.find(item => item.id === parseInt(data.item_id, 10))

    data.name = selectedItem && selectedItem.name
    data.grand_total = data.cost * data.quantity
    data.row_id = generateUniqueId()
    itemsArray.push(data)
    this.setState({
      purchaseOrderItems: itemsArray
    })
  }

  basicInfoInputChange = (value, input) => {
    this.setState({ [input]: value })
  }

  handleSavePurchaseOrder = async (
    purchaseOrderId,
    purchaseOrderSections,
    purchaseOrderItems,
    basicInfoData
  ) => {
    let grandTotal = 0
    purchaseOrderItems.forEach(item => {
      grandTotal += item.quantity * item.cost
    })
    try {
      if (+basicInfoData.shipping_address_id > 3) {
        basicInfoData.shipping_address = await this.validateVendorAdressFormAsync()
      }

      this.props.updateVendorPurchaseOrder({
        jobId: this.props.jobId,
        purchaseOrderId: purchaseOrderId,
        vendorId: this.state.vendorId,
        basicInfoData: basicInfoData,
        sectionData: purchaseOrderSections,
        itemsData: purchaseOrderItems,
        grandTotal: grandTotal,
        userId: this.props.userId
      })

      this.setState({
        basicInfoTerms: null,
        basicInfoShipTo: basicInfoData.shipping_address_id,
        purchaseOrderCreationStep: 0
      })
    } catch (error) {
      message.info('Please fill all the required fields')
      throw error
    }
  }
  setVendorAdressForm = form => {
    if (form && form.props && form.props.form) {
      this.vendorAdressForm = form.props.form
    }
  }

  onSectionNameChange = (index, value) => {
    const groupArray = this.state.purchaseOrderSections
    groupArray[_.findIndex(groupArray, { id: index })].name = value

    this.setState({
      purchaseOrderSections: groupArray
    })
  }

  changeCreateChangeOrderStep = step => {
    this.setState({
      purchaseOrderCreationStep: step
    })
  }

  updatePurchaseOrderSections = poSections => {
    this.setState({
      purchaseOrderSections: poSections
    })
  }

  updatePurchaseOrderItems = poItems => {
    this.setState({
      purchaseOrderItems: poItems
    })
  }

  setSelectedEstimateId = estimateId => {
    this.setState({
      selectedEstimateId: estimateId
    })
  }

  handlePanelChange = panelKey => {
    this.props.vendorPanelChange(panelKey)
    this.setState({
      activeKey: panelKey ? panelKey : 0
    })
  }

  setActiveKey = key => {
    this.setState({
      activeKey: key
    })
  }

  render() {
    const { data, vendorPurchaseOrders, purchaseOrder, getPurchaseOrder, allItems } = this.props
    const {
      purchaseOrderCreationStep,
      modalIsShowing,
      purchaseOrderSections,
      activeKey
    } = this.state

    const revisions = _.get(this.props, 'revisionActions.revisions')
    const loadingRevision = _.get(this.props, 'revisionActions.loading')

    const vendorsList = this.props.data.map(vendor => (
      <Panel header={vendor.name} key={vendor.organization_id} style={panelStyle}>
        <VendorPanel
          data={data}
          vendorPurchaseOrders={vendorPurchaseOrders}
          vendor={vendor}
          handleAddPurchaseOrderClick={this.handleAddPurchaseOrderClick}
          getPurchaseOrder={getPurchaseOrder}
          purchaseOrder={purchaseOrder}
          allItems={allItems}
          handleSavePurchaseOrder={this.handleSavePurchaseOrder}
          uploadingAttachments={this.props.uploadingAttachment}
          deletingAttachment={this.props.deletingAttachment}
          loadingAttachments={this.props.loadingAttachments}
          jobVendorAttachments={this.props.jobVendorAttachments}
          attachmentDetailsVisible={this.props.attachmentDetailsVisible}
          confirmAttachmentDelete={this.props.confirmAttachmentDelete}
          handleUpdateAttachmentDescription={this.props.handleUpdateAttachmentDescription}
          onDescriptionChange={this.props.onDescriptionChange}
          handleAttachmentRowClick={this.props.handleAttachmentRowClick}
          uploadVendorAttachment={this.props.uploadVendorAttachment}
          attachmentDescription={this.props.attachmentDescription}
          attachmentName={this.props.attachmentName}
          confirmDelete={this.props.confirmDelete}
          deleteVendor={this.props.deleteVendor}
          handleDeletePurchaseOrder={this.props.handleDeletePurchaseOrder}
          handlePurchaseOrderOpenModal={this.props.handlePurchaseOrderOpenModal}
          modalEditPurchaseOrderIsShowing={this.props.modalEditPurchaseOrderIsShowing}
          handlePurchaseOrderCloseModal={this.props.handlePurchaseOrderCloseModal}
          revisions={revisions}
          loadingRevision={loadingRevision}
          getAuditRevisions={this.props.getAuditRevisions}
          getRevisions={this.props.getRevisions}
          setVendorAdressForm={this.setVendorAdressForm}
          createNewItem={this.props.createNewItem}
          shouldRenderModal={this.props.shouldRenderModal}
          setVendorClicked={this.props.setVendorClicked}
        />
      </Panel>
    ))
    return (
      <div>
        <PurchaseOrderCreationSteps
          changeCreateChangeOrderStep={this.changeCreateChangeOrderStep}
          step={purchaseOrderCreationStep}
          modalIsShowing={modalIsShowing}
          handleCancel={this.handleCancel}
          handleCreate={this.handleCreate}
          setSelectedEstimateId={this.setSelectedEstimateId}
          // VendorPurchaseOrderBasicInfo
          basicInfoInputChange={this.basicInfoInputChange}
          basicInfoDescription={this.state.basicInfoDescription}
          terms={this.state.basicInfoTerms}
          shipTo={this.state.basicInfoShipTo}
          attention={this.state.basicInfoAttention}
          setVendorAdressForm={this.setVendorAdressForm}
          // PurchaseOrderEditor
          updatePurchaseOrderSections={this.updatePurchaseOrderSections}
          updatePurchaseOrderItems={this.updatePurchaseOrderItems}
          purchaseOrderSections={purchaseOrderSections}
          purchaseOrderItems={this.state.purchaseOrderItems}
          onSectionNameChange={this.onSectionNameChange}
          addSection={this.addSection}
          allItems={allItems}
          moveSectionDown={this.moveSectionDown}
          moveSectionUp={this.moveSectionUp}
          moveItemUp={this.moveItemUp}
          moveItemDown={this.moveItemDown}
          deleteSection={this.deleteSection}
          addItem={this.addItem}
          deleteItem={this.deleteItem}
          createNewItem={this.props.createNewItem}
        />
        <Collapse accordion activeKey={activeKey.toString()} onChange={this.handlePanelChange}>
          {vendorsList}
        </Collapse>
      </div>
    )
  }
}
const mapStateToProps = ({ auditActions, revisionActions }, ownProps) => ({
  auditActions,
  revisionActions
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(
    Object.assign(auditActions, revisionActions, purchaseOrderActions),
    dispatch
  )
})
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(VendorView))



// WEBPACK FOOTER //
// ./src/components/VendorView.js